import { LazyLoadImage } from 'react-lazy-load-image-component';

import { LABELS } from '../../../constants';
import { PriceComponent } from '../../home/price';

export const ProductCard = ({
    handleImageError,
    handleProductClick,
    handleProductNameClick,
    handleSeeDetailsClick,
    imageAlt,
    imageSrc,
    index,
    isGradProductTiles,
    isLimitedSizeProduct,
    isSoldOutProduct,
    priceComponentData,
    productName,
    productNameLink,
    promoMessage,
    scrollPosition,
    shouldDisplayPrice,
    shouldShowSeeDetails,
    googleAnalytics,
    sectionTitle
}) => (
    <div key={`ProductObj-${index}`} className="product">
        <div key={index} onClick={handleProductClick}>
            {!isGradProductTiles && promoMessage && <div className="sale-label">{LABELS.SALE}</div>}
            {isGradProductTiles && (promoMessage || isLimitedSizeProduct || isSoldOutProduct) && (
                <div className="promo-label-container">
                    {promoMessage && <span className="sale-label">{LABELS.SALE}</span>}
                    {isLimitedSizeProduct && <span className="limited-label">{LABELS.LIMITED_SIZES}</span>}
                    {isSoldOutProduct && <span className="sold-out-label">{LABELS.SOLD_OUT}</span>}
                </div>
            )}
            <LazyLoadImage
                className={`img-dimesions cursorPointer ${shouldShowSeeDetails && 'shopAllImg'}`}
                src={imageSrc}
                alt={imageAlt}
                scrollPosition={scrollPosition}
                onError={handleImageError}
                onClick={async () => {
                    googleAnalytics?.selectItemTrackingGASY25(
                        googleAnalytics?.catalogOSR,
                        googleAnalytics?.customerClassCode,
                        `[image clicked]: ${productName}`, 
                        '',
                        productName,
                        'button_click',
                        sectionTitle || 'GradProductTiles'
                    );
                    if (window?.jostensGaTracking?.gaEventsSpecPromise) {
                        await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
                    }
                    if (shouldShowSeeDetails) {                         
                        handleSeeDetailsClick && handleSeeDetailsClick() 
                    } else { 
                        handleProductNameClick && handleProductNameClick()
                    }
                }}
            />
        </div>
        <div className="product-name">
            {isGradProductTiles && productName && (
                <a href={productNameLink}
                    className="jos-ga-tracking-element"
                    data-jos-ga-tracking={JSON.stringify({
                        _resolveFields: {
                            businessUnit: { 
                                catalogOsr: googleAnalytics?.catalogOSR, 
                                customerClassCode: googleAnalytics?.customerClassCode
                            },
                            productLine: { 
                                catalogOsr: googleAnalytics?.catalogOSR 
                            }
                        },
                        clickText: productName, 
                        modalType: '', 
                        itemName: productName, 
                        actionType: 'button_click', 
                        categoryName: sectionTitle || 'GradProductTiles'
                    })}
                >
                    <div className="cursorPointer product-name-font">{productName}</div>
                </a>
            )}
            {!isGradProductTiles && (
                <div className='cursorPointer text-underline' onClick={async () => {
                    googleAnalytics?.selectItemTrackingGASY25(
                        googleAnalytics?.catalogOSR,
                        googleAnalytics?.customerClassCode,
                        productName, 
                        '',
                        productName,
                        'button_click',
                        sectionTitle || 'GradProductTiles'
                    );
                    if (window?.jostensGaTracking?.gaEventsSpecPromise) {
                        await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
                    }
                    handleProductNameClick && handleProductNameClick();
                }}>
                    {productName}
                </div>
            )}
            {shouldDisplayPrice && <PriceComponent data={priceComponentData} />}
        </div>
        <div className="promo-message-styles">{promoMessage}</div>
        {shouldShowSeeDetails && (
            <button
                className='btn btn-primary shopAllBtn'
                onClick={async () => {
                    googleAnalytics?.selectItemTrackingGASY25(
                        googleAnalytics?.catalogOSR,
                        googleAnalytics?.customerClassCode,
                        LABELS.SHOP_ALL, 
                        '',
                        productName,
                        'button_click',
                        sectionTitle || 'GradProductTiles'
                    );
                    if (window?.jostensGaTracking?.gaEventsSpecPromise) {
                        await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
                    }
                    handleSeeDetailsClick && handleSeeDetailsClick();
                }}
            >
                {LABELS.SHOP_ALL}
            </button>
        )}
    </div>
)